import React, { useState } from 'react';
import { Card, CardBody, Button, Alert } from 'reactstrap';
import { useSelector } from 'react-redux';
import { selectCountry } from '../../selectors/country';

const CreateTokenForm = ({ countryId, onTokenCreated, onCancel }) => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');

  const country = useSelector(selectCountry(countryId));

  const handleCreateToken = async () => {
    if (!countryId) {
      setError('Country ID non disponibile');
      return;
    }

    setIsCreating(true);
    setError('');

    try {
      // Apri il flusso OAuth per il paese selezionato
      const authUrl = `${process.env.REACT_APP_WS_FUNCTION_URL}/facebook/auth/${countryId}`;

      const popup = window.open(
        authUrl,
        'facebook-oauth',
        'width=600,height=700,scrollbars=yes,resizable=yes',
      );

      // Monitora la chiusura del popup
      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed);
          setIsCreating(false);
          // Notifica che il token è stato creato
          onTokenCreated();
        }
      }, 1000);
    } catch (error) {
      console.error('Errore nella creazione del token:', error);
      setError('Errore nella creazione del token. Riprova più tardi.');
      setIsCreating(false);
    }
  };

  return (
    <Card>
      <CardBody>
        <h5 className="mb-3">🆕 Crea Nuovo Token Facebook</h5>

        {error && (
          <Alert color="danger" className="mb-3">
            {error}
          </Alert>
        )}

        <p className="text-muted mb-3">
          Stai per creare un token Facebook per il paese{' '}
          <strong>{country.name}</strong>. Verrà aperta una finestra per
          autorizzare l'applicazione tramite Facebook OAuth.
        </p>

        {!countryId && (
          <Alert color="warning" className="mb-3">
            <i className="bx bx-error mr-1"></i>
            Nessun paese selezionato nel Dashboard. Seleziona un paese prima di
            creare un token.
          </Alert>
        )}

        <div className="d-flex gap-2">
          <Button
            color="primary"
            onClick={handleCreateToken}
            disabled={isCreating || !countryId}
            className="mr-2">
            {isCreating ? (
              <>
                <i className="bx bx-loader bx-spin mr-1"></i>
                Creazione in corso...
              </>
            ) : (
              <>
                <i className="bx bx-plus mr-1"></i>
                Crea Token
              </>
            )}
          </Button>

          {onCancel && (
            <Button
              color="secondary"
              outline
              onClick={onCancel}
              disabled={isCreating}>
              Annulla
            </Button>
          )}
        </div>

        <div className="mt-3">
          <small className="text-muted">
            <i className="bx bx-info-circle mr-1"></i>
            Dovrai autorizzare l'applicazione tramite Facebook per completare la
            creazione del token.
          </small>
        </div>
      </CardBody>
    </Card>
  );
};

export default CreateTokenForm;
